"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_68_0_0 = void 0;
/**
 * Migrate to 68.0.0
 *
 * delete QuerschnittUS on Leitung
 * delete LeitungsaufbauUS on Leitung
 *
 * patch querschnittUS to querschnitt and remove querschnittUS
 * patch leitungsaufbauImperial to leitungsaufbau and remove leitungsaufbauImperial
 *
 */
const migration_68_0_0 = (json) => {
    // remove US properties on Leitungen
    if (json.Leitungen) {
        json.Leitungen.forEach((leitungJson) => {
            delete leitungJson.QuerschnittUS;
            delete leitungJson.LeitungsaufbauUS;
        });
    }
    // patch US/imperial LeitungFilterProperties
    const leitungFilterProperties = json.LeitungFilterProperties;
    if (leitungFilterProperties) {
        if (leitungFilterProperties.querschnittUS) {
            leitungFilterProperties.querschnitt = leitungFilterProperties.querschnittUS;
            delete leitungFilterProperties.querschnittUS;
        }
        if (leitungFilterProperties.leitungsaufbauImperial) {
            leitungFilterProperties.leitungsaufbau = leitungFilterProperties.leitungsaufbauImperial;
            delete leitungFilterProperties.leitungsaufbauImperial;
        }
        json.LeitungFilterProperties = leitungFilterProperties;
    }
    return json;
};
exports.migration_68_0_0 = migration_68_0_0;
//# sourceMappingURL=migration_68_0_0.js.map